/* UnauthenticatedLayout - Dark Theme for Auth Pages */

.container {
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: var(--impact-bg-primary);
    padding: 0 !important;
    color: var(--impact-text-primary);
    font-family: var(--impact-font-family);
}

.wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    max-width: 402px;
    margin: 0 auto;
}

/* Header with logo and language selector */
.header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3rem var(--impact-spacing-page) 1.5rem;
    flex-shrink: 0;
    margin: 0 !important;
}

.logo {
    height: 29px;
    width: auto;
}

/* Language selector - pill button in top right, aligned with logo */
.languageSelector {
    position: absolute;
    right: var(--impact-spacing-page);
    top: 3rem;
    z-index: 1001;
}

.languageButton {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.75rem;
    border: 1px solid var(--impact-border-light);
    border-radius: var(--impact-radius-pill);
    background: transparent;
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-lang);
    font-weight: var(--impact-font-weight-normal);
    cursor: pointer;
    transition: background-color var(--transition-base);
    min-width: 50px;
    height: 29px;
}

.languageButton:hover {
    background: rgba(250, 250, 250, 0.1);
}

/* Language dropdown */
.languageDropdown {
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    background: var(--impact-bg-input);
    border: 1px solid var(--impact-border-button);
    border-radius: 0.5rem;
    padding: 0.5rem 0;
    min-width: 120px;
    z-index: var(--z-floating);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.languageOption {
    display: block;
    width: 100%;
    padding: 0.5rem 1rem;
    background: transparent;
    border: none;
    color: var(--impact-text-primary);
    text-align: left;
    cursor: pointer;
    font-size: var(--impact-font-size-small);
    transition: background-color 0.15s ease;
}

.languageOption:hover {
    background: rgba(250, 250, 250, 0.1);
}

.languageOptionActive {
    color: var(--impact-text-accent);
    font-weight: var(--impact-font-weight-label);
}

/* Main content area */
.content {
    flex: 1 0 auto;
    padding: var(--impact-spacing-section) var(--impact-spacing-page);
    display: flex;
    flex-direction: column;
    margin: 0 !important;
}

/* Page title style */
.pageTitle {
    font-size: var(--impact-font-size-title);
    font-weight: var(--impact-font-weight-title);
    color: var(--impact-text-primary);
    margin-bottom: var(--impact-spacing-section);
    line-height: 1.2;
}

/* Form section */
.formSection {
    margin-bottom: var(--impact-spacing-section);
}

/* Input label style */
.inputLabel {
    display: block;
    font-size: var(--impact-font-size-label);
    font-weight: var(--impact-font-weight-label);
    color: var(--impact-text-primary);
    margin-bottom: 0.75rem;
}

/* Pill-shaped input wrapper */
.inputWrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.pillInput {
    width: 100%;
    height: var(--impact-input-height);
    padding: var(--impact-spacing-input) 3.5rem var(--impact-spacing-input) 1.25rem;
    background: var(--impact-bg-input);
    border: none;
    border-radius: var(--impact-radius-pill);
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-input);
    font-family: var(--impact-font-family);
}

.pillInput::placeholder {
    color: var(--impact-text-placeholder);
}

.pillInput:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--impact-text-accent);
}

.pillInput:-webkit-autofill,
.pillInput:-webkit-autofill:hover,
.pillInput:-webkit-autofill:focus,
.pillInput:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px var(--impact-bg-input) inset !important;
    -webkit-text-fill-color: var(--impact-text-primary) !important;
    box-shadow: 0 0 0 30px var(--impact-bg-input) inset !important;
    background-color: var(--impact-bg-input) !important;
    caret-color: var(--impact-text-primary);
    transition: background-color 5000s ease-in-out 0s;
}

/* Pill input without submit button (standard padding) */
.pillInputStandard {
    width: 100%;
    height: var(--impact-input-height);
    padding: var(--impact-spacing-input) 1.25rem;
    background: var(--impact-bg-input);
    border: none;
    border-radius: var(--impact-radius-pill);
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-input);
    font-family: var(--impact-font-family);
}

.pillInputStandard::placeholder {
    color: var(--impact-text-placeholder);
}

.pillInputStandard:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--impact-text-accent);
}

/* Pill-shaped select dropdown */
.pillSelect {
    width: 100%;
    height: var(--impact-input-height);
    padding: var(--impact-spacing-input) 2.5rem var(--impact-spacing-input) 1.25rem;
    background: var(--impact-bg-input);
    border: none;
    border-radius: var(--impact-radius-pill);
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-input);
    font-family: var(--impact-font-family);
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23fafafa' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 12px;
}

.pillSelect:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--impact-text-accent);
}

.pillSelect option {
    background: var(--impact-bg-input);
    color: var(--impact-text-primary);
}

/* Full-width submit button (auth themed) */
.submitButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: var(--impact-social-height);
    background: var(--impact-bg);
    border: 1px solid var(--impact-border-button);
    border-radius: var(--impact-radius-pill);
    color: var(--impact-social-text);
    font-size: var(--impact-font-size-button);
    font-weight: var(--impact-font-weight-normal);
    font-family: var(--impact-font-family);
    cursor: pointer;
    transition: background-color var(--transition-base), transform 0.1s ease;
    margin-top: var(--impact-spacing-section);
}

.submitButton:hover:not(:disabled) {
    background: #f0f0f0;
}

.submitButton:active:not(:disabled) {
    transform: scale(0.98);
}

.submitButton:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Circular submit button inside input */
.circularSubmit {
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    width: var(--impact-submit-size);
    height: var(--impact-submit-size);
    border-radius: var(--impact-radius-circle);
    background: var(--impact-submit-bg);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color var(--transition-base), transform 0.1s ease;
    padding: 0;
}

.circularSubmit:hover:not(:disabled) {
    background: var(--color-white);
}

.circularSubmit:active:not(:disabled) {
    transform: translateY(-50%) scale(0.95);
}

.circularSubmit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.circularSubmit svg {
    color: var(--impact-submit-icon);
    width: 24px;
    height: 24px;
}

/* Password visibility toggle */
.visibilityToggle {
    position: absolute;
    right: calc(var(--impact-submit-size) + 8px);
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: var(--impact-text-primary);
    cursor: pointer;
    padding: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Error message */
.errorMessage {
    color: var(--impact-text-error);
    font-size: var(--impact-font-size-small);
    margin-top: 0.5rem;
    text-align: center;
}

/* OR divider */
.divider {
    display: flex;
    align-items: center;
    margin: var(--impact-spacing-section) 0;
}

.dividerLine {
    flex: 1;
    height: 1px;
    background: var(--impact-border-divider);
}

.dividerText {
    padding: 0 1rem;
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-small);
    font-weight: var(--impact-font-weight-normal);
}

/* Social buttons section */
.socialSection {
    display: flex;
    flex-direction: column;
    gap: var(--impact-spacing-button-gap);
}

.socialButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: var(--impact-social-height);
    background: var(--impact-bg);
    border: 1px solid var(--impact-border-button);
    border-radius: var(--impact-radius-pill);
    color: var(--impact-social-text);
    font-size: var(--impact-font-size-button);
    font-weight: var(--impact-font-weight-normal);
    font-family: var(--impact-font-family);
    cursor: pointer;
    transition: background-color var(--transition-base), transform 0.1s ease;
    text-decoration: none;
    gap: 0.75rem;
}

.socialButton:hover {
    background: #f0f0f0;
}

.socialButton:active {
    transform: scale(0.98);
}

.socialButton:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.socialIcon {
    width: 25px;
    height: 25px;
}

/* Footer links section */
.footer {
    padding: var(--impact-spacing-section) var(--impact-spacing-page);
    text-align: center;
    margin: 0 !important;
}

.footerText {
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-button);
    font-weight: var(--impact-font-weight-normal);
}

.footerLink {
    color: var(--impact-text-accent);
    font-size: var(--impact-font-size-button);
    font-weight: var(--impact-font-weight-accent);
    text-decoration: none;
    cursor: pointer;
}

.footerLink:hover {
    text-decoration: underline;
}

/* Back button for sub-pages */
.backButton {
    position: absolute;
    left: var(--impact-spacing-page);
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: var(--impact-text-primary);
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.backButton svg {
    width: 36px;
    height: 36px;
}

/* Forgot password link */
.forgotPasswordLink {
    display: block;
    text-align: center;
    margin-top: 1rem;
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-button);
    text-decoration: none;
}

.forgotPasswordLinkBold {
    color: var(--impact-text-primary);
    font-weight: var(--impact-font-weight-normal);
    text-decoration: none;
}

/* Reset password button (full width, outlined) */
.resetPasswordButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: var(--impact-social-height);
    background: var(--impact-bg);
    border: 1px solid var(--impact-border-button);
    border-radius: var(--impact-radius-pill);
    color: var(--impact-social-text);
    font-size: var(--impact-font-size-button);
    font-weight: var(--impact-font-weight-normal);
    font-family: var(--impact-font-family);
    cursor: pointer;
    transition: background-color var(--transition-base);
    text-decoration: none;
    margin-top: var(--spacing-md);
}

.resetPasswordButton:hover {
    background: #f0f0f0;
}

/* Page subtitle */
.pageSubtitle {
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-button);
    font-weight: var(--impact-font-weight-normal);
    margin-bottom: var(--impact-spacing-section);
    line-height: 1.5;
}

/* Success state container */
.successContainer {
    text-align: center;
    padding: var(--impact-spacing-section) 0;
}

.successIcon {
    width: 64px;
    height: 64px;
    color: var(--impact-text-accent);
    margin-bottom: 1.5rem;
}

.successMessage {
    color: var(--impact-text-primary);
    font-size: var(--impact-font-size-button);
    line-height: 1.6;
    margin-bottom: 0;
}

/* Error icon */
.errorIcon {
    width: 64px;
    height: 64px;
    color: var(--impact-text-error);
    margin-bottom: 1.5rem;
}

/* Loading spinner */
.loadingSpinner {
    width: 48px;
    height: 48px;
    color: var(--impact-text-accent);
    margin-bottom: 1.5rem;
}

/* Email display for password step */
.emailDisplay {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    font-size: var(--impact-font-size-small);
    color: var(--impact-text-primary);
}

.changeEmailButton {
    background: transparent;
    border: none;
    color: var(--impact-text-accent);
    cursor: pointer;
    font-size: var(--impact-font-size-small);
    padding: 0;
}

.changeEmailButton:hover {
    text-decoration: underline;
}

/* Desktop adjustments */
@media (min-width: 576px) {
    .container {
        justify-content: center;
        padding: 2rem !important;
    }

    .wrapper {
        min-height: auto;
        background: var(--impact-bg-primary);
        border-radius: 1rem;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    }

    .content {
        padding: var(--impact-spacing-section) var(--impact-spacing-section);
    }

    .footer {
        padding: var(--impact-spacing-section);
    }
}

/* Two-panel layout (login page with sideImage) */
.wrapperWithImage {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    max-width: 402px;
    margin: 0 auto;
}

.formPanel {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100vh;
    min-height: 100dvh;
}

.imagePanel {
    display: none;
}

@media (min-width: 576px) {
    .wrapperWithImage {
        min-height: auto;
        background: var(--impact-bg-primary);
        border-radius: 1rem;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    }

    .formPanel {
        min-height: auto;
    }
}

@media (min-width: 768px) {
    .wrapperWithImage {
        flex-direction: row;
        max-width: 985px;
        background: var(--impact-bg-primary);
        overflow: hidden;
        border-radius: 1rem;
        box-shadow: 0 0 40px rgba(0, 0, 0, 0.8);
    }

    .formPanel {
        flex: 0 0 40%;
        max-width: 40%;
        background: var(--impact-bg-primary);
        border-radius: 1rem;
        z-index: 1;
        min-height: 640px;
    }

    .imagePanel {
        display: block;
        flex: 0 0 calc(60% + 1rem);
        max-width: calc(60% + 1rem);
        position: relative;
        overflow: hidden;
        border-radius: 0 1rem 1rem 0;
        margin-left: -1rem;
        padding-left: 1rem;
    }

    .sideImage {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .grainOverlay {
        position: absolute;
        inset: 0;
        pointer-events: none;
        mix-blend-mode: overlay;
        opacity: 0.4;
    }

    .grainOverlay svg {
        width: 100%;
        height: 100%;
    }
}
